import $ from 'jquery';

import mediaVideoService from '../../../Services/Media/video';

window._define('bridge/media/video', $.extend({}, mediaVideoService));
